import imageDe from '../images/de/uploader-abbottLibre-problem-2.png';
import imageEn from '../images/en/uploader-abbottLibre-problem-2.png';
import imageEs from '../images/es/uploader-abbottLibre-problem-2.png';
import imageFi from '../images/fi/uploader-abbottLibre-problem-2.png';
import imageFr from '../images/fr/uploader-abbottLibre-problem-2.png';
import imageIt from '../images/it/uploader-abbottLibre-problem-2.png';
import imageNo from '../images/no/uploader-abbottLibre-problem-2.png';
import imageSv from '../images/sv/uploader-abbottLibre-problem-2.png';

export const uploaderTryAgainImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
